<template>
	<div class="drawer">
		<el-drawer
		size="80%"
		title="解单列表"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div style="padding:50px 0px;">
				<div class="content" style="padding:0;">
					<el-table :data="guadanList" style="width: 100%;margin-bottom: 20px;">
						<el-table-column prop="memberName" label="姓名" width="200">
						</el-table-column>
						<el-table-column prop="petName" label="宠物" width="200">
						</el-table-column>
						<el-table-column prop="petType" label="品种" width="150">
						</el-table-column>
						<el-table-column prop="totalMoney" label="总价" width="100">
						</el-table-column>
						<el-table-column label="备注">
							<template slot-scope="scope">
								{{scope.row.remark.split("_explain_")[0]}}
							</template>
						</el-table-column>
						<el-table-column prop="createTime" label="挂单时间" width="180">
							<template slot-scope="scope">
								{{$public.FTime(scope.row.createTime)}}
							</template>
						</el-table-column>
						<el-table-column label="操作" width="150">
							<template slot-scope="scope">
								<el-button @click="jiedan(scope.row)" type="success" size="small">解单</el-button>
								<el-button @click="jiedan_del(scope.row)" type="danger" size="small">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<page :total="page.total" @change="pageChange"></page>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import page from "../../../../components/page.vue"
	export default {
		components:{page},
		data() {
			return {
				drawerStatus:false,
				guadanList:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
			}
		},
		computed:{
			
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
			this.getGuadanList();
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			// 处理表格数据
			handleTable(userInfo,row){
				let table = JSON.parse(row.orderContent);
				this.$util.getActivityOfProduct(userInfo,table).then(res=>{
					let list = res;
					for(let i=0;i<list.length;i++){
						table[i].activityList = list[i].list;
					}
					// for(let i=0;i<table.length;i++){
					// 	let goods = table[i];
					// 	if(this.$public.isNull(goods.activityId)){
					// 		if(goods.activityList[0].auto_matching>0){
					// 			goods.activityId = goods.activityList[0]._id
					// 			goods.activityName = goods.activityList[0].name
					// 		}
					// 	}else{
					// 		let index = -1;
					// 		for(let a=0;a<goods.activityList.length;a++){
					// 			let obj = goods.activityList[a];
					// 			if(goods.activityId===obj._id){
					// 				console.log(goods.activityId)
					// 				console.log(obj._id)
					// 				index = a
					// 			}
					// 		}
					// 		if(index===-1){
					// 			alert('活动过期了')
					// 			if(goods.activityList[0].auto_matching>0){
					// 				goods.activityId = goods.activityList[0]._id
					// 				goods.activityName = goods.activityList[0].name
					// 			}
					// 		}else{
					// 			goods.activityId = goods.activityList[index]._id;
					// 			goods.activityName = goods.activityList[index].name;
					// 		}
					// 	}
					// }
					this.$store.commit('mendian/set_saleList',table)
					this.$emit('submit',{type:'success'})
				})
			},
			jiedan(row) {
				if(row.memberId==="sankeId"){
					this.$store.commit('mendian/set_isSanke',true)
					let userInfo = this.$store.state.mendian.userInfo;
					this.handleTable(userInfo,row)
					this.$store.commit('mendian/set_remarkGuahao',row.remark.split('_explain_')[0])
					this.$store.commit('mendian/set_remark',row.remark.split('_explain_')[1])
					this.$store.commit('mendian/set_jiedanItem',row)
					this.$store.commit('mendian/set_curDiscountCard',JSON.parse(row.couponContent))
				}else{
					let params = {
						"id": row.memberId,
					}
					this.$http.get('/api/Member/Single', params).then(res => {
						if(res.code==0){
							this.$store.commit('mendian/set_isSanke',false)
							this.$store.commit('mendian/set_userInfo',res.data)
							this.$store.commit("mendian/set_curPetId",row.petId)
							let userInfo = this.$store.state.mendian.userInfo;
							this.handleTable(userInfo,row)
							this.$store.commit('mendian/set_remarkGuahao',row.remark.split('_explain_')[0])
							this.$store.commit('mendian/set_remark',row.remark.split('_explain_')[1])
							this.$store.commit('mendian/set_jiedanItem',row)
							this.$store.commit('mendian/set_curDiscountCard',JSON.parse(row.couponContent))
						}
					})
				}
			},
			jiedan_del(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete('/api/HandOrder/Delete', {"hangOrderId": row.recordId}).then(res => {
						console.log('删除挂单',res)
						this.page.page=1;
						this.getGuadanList();
					})
				})
			},
			pageChange(a) {
				this.page.page=a;
				this.getGuadanList();
			},
			getGuadanList(){
				let params = {
					"keyword": '',
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				this.$http.get('/api/HandOrder/List', params).then(res => {
					if (res.code == 0) {
						this.guadanList = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.label{
				display: inline-block;width:150px;text-align: right;
			}
		}
		
	}
	
</style>
